import Config from '../config/constants';
import Configuration from '../model/Configuration';

const retrieveConfigurationForSession = async (
    sessionId: string | null,
): Promise<Configuration> => {
    var config: Configuration = {
        brandName: 'CAREKIT',
        jwt: undefined,
        patientIdentifier: '',
        tenantId: '',
        sessionId: '',
        disablePrint: false,
        disablePrintMobileOnly: false,
    };
    try {
        if (sessionId === null || sessionId === undefined) {
            return config;
        }

        const request: RequestInit = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };

        await fetch(`${Config.AUTHORIZATION_BASE_URL}/RetrieveConfiguration/${sessionId}`, request)
            .then((response) => response.json())
            .then((json) => {
                config = json as Configuration;
                setSessionStorageObject(Config.LOCAL_CONFIGURATION, config);
            })
            .catch((error: Error) => {
                console.log(error.message);
            });
    } catch (error) {
        console.log(error);
    }

    return config;
};

const retrieveSessionConfiguration = function (): Configuration {
    return getSessionStorageObject(Config.LOCAL_CONFIGURATION) as Configuration;
};

const retrieveSessionJwt = function (): string | undefined {
    let config = retrieveSessionConfiguration();
    if (config === null) {
        return undefined;
    }
    return config.jwt;
};

const setSessionStorageObject = function (key: string, object: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(object));
};

const getSessionStorageObject = function (key: string): any {
    const object = window.sessionStorage.getItem(key);
    return object && JSON.parse(object);
};

const services = {
    retrieveConfigurationForSession,
    retrieveSessionConfiguration,
    retrieveSessionJwt,
};

export default services;
